var _g, _circle, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCivilianFirearms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.206 168.333H499.592C502.812 168.333 505.855 169.853 507.901 172.465C509.936 175.076 510.754 178.514 510.124 181.83L499.805 241.667C499.805 241.667 170.901 241.667 155.006 241.667C148.016 231.987 143.668 214.663 143.668 202.18C143.668 195.944 148.473 190.897 154.411 190.897C160.348 190.897 165.153 195.944 165.153 202.18C165.153 211.829 169.247 220.824 175.939 227.184C182.459 220.987 186.637 212.122 186.637 202.18C186.637 195.944 191.442 190.897 197.379 190.897H430.691L449.028 171.639C451.042 169.523 453.77 168.333 456.623 168.333H483.206Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.898 303.718H154.411C148.474 303.718 143.669 298.672 143.669 292.436L143.669 260H495.508L488.641 294.65C487.634 299.917 483.228 303.718 478.109 303.718H377.71L363.572 348.273C359.177 362.112 346.893 371.41 333.003 371.41H270.289L260.859 401.114C256.233 415.712 259.789 431.533 270.143 442.407C273.217 445.636 274.14 450.484 272.472 454.703C270.815 458.924 266.891 461.667 262.549 461.667H154.411C151.043 461.667 147.865 460.003 145.83 457.182C143.805 454.351 143.155 450.693 144.078 447.289L179.221 318.107C180.165 314.67 179.524 311.056 177.479 308.202C175.423 305.349 172.297 303.718 168.898 303.718ZM355.072 303.718H298.878H291.775L277.451 348.846H333.003C337.629 348.846 341.731 345.75 343.2 341.134L355.072 303.718Z",
    fill: "#FCFCFC"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white",
    transform: "translate(116 108)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivilianFirearms);
export default __webpack_public_path__ + "static/media/civilian-firearms.13c336ad9aa28b09e18a980b4a26989a.svg";
export { ForwardRef as ReactComponent };